import { useEffect, useState } from "react";
import { fetchMatterPorts } from "../services/fetchRealsData";
import type { RealsProperty } from "../interfaces/realsProperties";

export const useMatterPort = () => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [data, setData] = useState<RealsProperty[]>(() => {
		const cachedData = sessionStorage.getItem("matterportData");
		return cachedData ? JSON.parse(cachedData) : [];
	});
	const [error, setError] = useState<string | null>(null);

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		if (data.length === 0) {
			setIsLoading(true);
			setError(null);

			fetchMatterPorts()
				.then((fetchedData) => {
					setData(fetchedData);
					sessionStorage.setItem("matterportData", JSON.stringify(fetchedData));
				})
				.catch((err) => {
					console.log("Error fetching data:", err);
					setError("Failed to fetch data");
				})
				.finally(() => {
					setIsLoading(false);
				});
		}
	}, []);

	const getVideoByIndex = (index: number) => {
		if (index < 0 || index >= data.length) {
			return null;
		}
		return data[index];
	};

	const getVideos = (limit: number, page: number) => {
		const skip = (page - 1) * limit;
		const paginatedData = data.slice(skip, skip + limit);
		return paginatedData.length > 0 ? paginatedData : null;
	};

	return {
		isLoading,
		data,
		error,
		getVideoByIndex,
		getVideos,
	};
};
